module.exports = __webpack_public_path__ + "src/images/measurements/shoulderWidth.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/shoulderWidth.jpg
// module id = 1157
// module chunks = 0